import React, { useRef, useState } from 'react'
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import Reveal from 'react-reveal/Reveal'
import Flip from 'react-reveal/Flip';



function Home() {

    const [formData, setFormData] = useState({});

    const changeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }


    const submitHandler = (e) => {
        e.preventDefault()
        const config = {
            Username: "devlord.coder@yopmail.com",
            Password: "28BC8A017562771267FC89179FB7C508E0A1",
            Host: "smtp.elasticemail.com",
            Port: "2525",
            To: 'devlord.coder@yopmail.com',
            From: formData.email,
            Subject: "This is the subject",
            Body: `${formData.subject} connected to you!`
        };
        if (window.Email) {
            window.Email.send(config).then(() => alert("email sent!"));
        }
    }

    return (
        <React.Fragment>



            <header className="header-area header-sticky">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <nav className="main-nav">
                                <a href="#" className="logo">
                                    <img src="/logo4.png" />
                                </a>

                                <ul className="nav">
                                    <li><a href="#welcome" className="active">Home</a></li>
                                    <li><a href="#features">About</a></li>
                                    <li><a href="#testimonials">Comments</a></li>
                                    <li><a href="#pricing-plans">Pricing Tables</a></li>


                                    <li><a href="#work-process">Projects</a></li>
                                    <li><a href="#contact-us">Contact Us</a></li>
                                </ul>
                                <a className='menu-trigger'>
                                    <span>Menu</span>
                                </a>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>

            <div className="welcome-area" id="welcome">

                <div className="header-text">
                    <div className="container">
                        <div className="row">
                             <br />
                            <div className="offset-xl-3 col-xl-6 offset-lg-2 col-lg-8 col-md-12 col-sm-12">
                                <h1> <strong>HI! Enjoy our Amazing Skills</strong></h1>
                                <p>We provide custom software development and IT outsourcing services.
                                     Our developers build custom software for individuals, startups, 
                                     and small to medium business. Our Uniqueness is our magic! We always have something unique to offer.We excel
                                     in providing reliable and customized IT solutions for your different types of requirements at minimal cost.</p>
                                <a href="#features" className="main-button-slider">Discover More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br /> <br />
            <section className="section home-feature">
                <div className="container">

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">

                                <div className="col-lg-4 col-md-6 col-sm-6 col-12" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.2s" >
                                    <Fade left>
                                        <div className="features-small-item" style={{ borderBottom: "2px solid black" }}>
                                            <div className="icon">

                                            </div>
                                            <h5 className="features-title">HTML & CSS</h5>
                                            <p>HTML (Hypertext Markup Language) and CSS (Cascading Style Sheets) are two 
                                                fundamental technologies for building websites.
                                                    Together, HTML and CSS form the backbone of modern web design. </p>
                                        </div>
                                    </Fade>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-6 col-12" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.2s" >
                                    <Zoom>
                                        <div className="features-small-item" style={{ borderBottom: "2px solid black" }}>
                                            <div className="icon2">

                                            </div>
                                            <h5 className="features-title">Javascript</h5>
                                            <p>JavaScript is a programming language that is commonly used to add interactivity
                                                 and dynamic functionality to web pages. It was first developed in the mid-1990s as a way
                                                  to make web pages more interactive and responsive.

                                                      </p>
                                        </div>
                                    </Zoom>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-6 col-12" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.2s" >
                                    <Fade right>
                                        <div className="features-small-item" style={{ borderBottom: "2px solid black" }}>
                                            <div className="icon3">

                                            </div>
                                            <h5 className="features-title">React.js</h5>
                                            <p>ReactJS is an open-source JavaScript library that is used for building user interfaces. 
                                                Developed by Facebook, React is widely used in web development for its ability to build
                                              complex and dynamic UI components.</p>
                                        </div>
                                    </Fade>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-6 col-12" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.2s" >
                                    <Fade left>
                                        <div className="features-small-item" style={{ borderBottom: "2px solid black" }}>
                                            <div className="icon4">

                                            </div>
                                            <h5 className="features-title">Node.js</h5>
                                            <p>Node.js is a cross-platform, open-source, and runtime environment that
                                                 allows developers to build fast and scalable network applications using
                                                  JavaScript. It is built on the V8 JavaScript engine used by the Google 
                                                  Chrome web browser.
</p>
                                        </div>
                                    </Fade>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-6 col-12" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.4s">
                                    <Zoom>
                                        <div className="features-small-item" style={{ borderBottom: "2px solid black" }}>
                                            <div className="icon5">

                                            </div>
                                            <h5 className="features-title">PHP</h5>
                                                                        <p>PHP (Hypertext Preprocessor) is a popular server-side scripting language designed primarily 
                                                                            for web development. It was created by Rasmus Lerdorf in 1994 and is now maintained by The PHP Group.</p>
                                        </div>
                                    </Zoom>
                                </div>

                                <div className="col-lg-4 col-md-6 col-sm-6 col-12" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.6s">
                                    <Fade right>
                                        <div className="features-small-item" style={{ borderBottom: "2px solid black" }}>
                                            <div className="icon6">

                                            </div>
                                            <h5 className="features-title">MYSQL</h5>
                                            <p>MySQL is a popular open-source relational database management system (RDBMS) 
                                                that is widely used for web applications and other data-driven projects. 
                                                It  is one   of the most widely used databases in the world.</p>
                                        </div>
                                    </Fade>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <Fade right>
                <section className="section padding-top-70 padding-bottom-0" id="features">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12 align-self-center" data-scroll-reveal="enter left move 30px over 0.6s after 0.4s">
                                <img src="/undraw_business_chat_re_gg4h.svg" className="rounded img-fluid d-block mx-auto" alt="App" />
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6 col-md-12 col-sm-12 align-self-center mobile-top-fix">
                                <div className="left-heading">
                                    <h2 className="section-title">Let’s discuss about you project</h2>
                                </div>
                                <div className="left-text">
                                    <p> I would be happy to discuss your project further.
                                         Please let me know when you have some time to chat so we can go over
                                          the details and see how I can help."

                                                By expressing your willingness to talk and your availability to work on the project,
                                                you are showing your interest and commitment to the project, and also giving the person
                                                an opportunity to share their vision and requirements with you. This can help build a
                                                rapport and set the stage for a productive collaboration.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hr"></div>
                            </div>
                        </div>
                    </div>
                </section>
            </Fade>
            <Fade left>
                <section className="section padding-bottom-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 col-sm-12 align-self-center mobile-bottom-fix">
                                <div className="left-heading">
                                    <h2 className="section-title">We can we help you to grow your business</h2>
                                </div>
                                <div className="left-text">
                                    <p> Dear client, I believe that I can assist you in growing your project. 
                                        I have experience and expertise in this area, and I am confident that
                                         I can provide valuable insights and solutions that will help your project succeed.
                                          If you are interested, I would be happy to discuss how we can work together to 
                                          achieve your goals. Thank you for considering my services.</p>
                                </div>
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-5 col-md-12 col-sm-12 align-self-center mobile-bottom-fix-big" data-scroll-reveal="enter right move 30px over 0.6s after 0.4s">
                                <img src="/undraw_educator_re_ju47.svg" className="rounded img-fluid d-block mx-auto" alt="App" />
                            </div>
                        </div>
                    </div>
                </section>
            </Fade>
            <hr />
            <Fade right>
                <section className="section padding-top-70 padding-bottom-0" id="features">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12 align-self-center" data-scroll-reveal="enter left move 30px over 0.6s after 0.4s">
                                <img src="/ni.png" className="rounded img-fluid d-block mx-auto" alt="App" />
                            </div>
                            <div className="col-lg-1"></div>
                            <div className="col-lg-6 col-md-12 col-sm-12 align-self-center mobile-top-fix">
                                <div className="left-heading">
                                    <h2 className="section-title">Get your certificate</h2>
                                </div>
                                <div className="left-text">
                                    <p> You will not only gain valuable knowledge and 
                                        insights in your field of interest, but you will also have the opportunity 
                                        to receive a useful certificate upon completion. This certificate can serve
                                         as a testament to your dedication and commitment to professional development, 
                                                          and may be recognized by potential employers or educational institutions.

                                                            We believe that our lectures can offer a valuable experience to anyone 
                                                            looking to enhance their knowledge and skills, and we would be delighted 
                                                            to have you join us. Please do not hesitate to reach out if you have any 
                                                            questions or concerns.

                                                            Thank you for your time, and we look forward to hearing from you soon.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hr"></div>
                            </div>
                        </div>
                    </div>
                </section>
            </Fade>

            <section className="counter">
                <div className="content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="count-item decoration-bottom">
                                    <strong>42</strong>
                                    <span> School Projects</span>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="count-item decoration-top">
                                    <strong>11</strong>
                                    <span>Remote Work</span>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="count-item decoration-bottom">
                                    <strong>10</strong>
                                    <span>Awards</span>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="count-item">
                                    <strong>NILEST</strong>
                                    <span>School</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="section" id="testimonials">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="center-heading">
                                <h2 className="section-title">Comments!</h2>
                            </div>
                        </div>
                       
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <Fade left>
                            <div className="team-item">
                                <div className="team-content">

                                    <p>I am extremely impressed with
                                         the website that you created 
                                         for me! It is not only visually appealing, 
                                         but also highly functional and user-friendly. The layout is intuitive and easy
                                          to navigate, and the content is well-organized and informative.
                                        Thank you so much!</p>
                                    <div className="user-image">
                                        <i><img src="/jay.jpeg" alt="" /></i>
                                    </div>
                                    <div className="team-info">
                                        <h3 className="user-name">Jethro Adamu</h3>
                                        <span>Founder of Zazzau Tailoring</span>
                                    </div>
                                </div>
                            </div>
                            </Fade>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <Zoom>
                            <div className="team-item">
                                <div className="team-content">

                                    <p>I am proud to have completed the program and 
                                        grateful for the opportunity to learn from 
                                        such experienced and talented instructors.
                                         Thank you for providing a top-notch education 
                                         that has prepared me for a bright future in the 
                                         field of programming.</p>
                                    <div className="user-image">
                                        <i><img src="/mentor.jpeg" alt="" /></i>
                                    </div>
                                    <div className="team-info">
                                        <h3 className="user-name">Ahmad Muhammad</h3>
                                        <span>Ex Student of Dev-lord</span>
                                    </div>
                                </div>
                            </div>
                            </Zoom>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <Fade right>
                            <div className="team-item">
                                <div className="team-content">

                                    <p>Thank you once again dev-lord for all that you did to make this project a success. Your
                                         efforts did not go unnoticed, and I am truly grateful to have had the
                                          opportunity to work with someone as talented and dedicated as you.</p>
                                    <div className="user-image">
                                        <i><img src="/bash.jpeg" alt="" /></i>
                                    </div>
                                    <div className="team-info">
                                        <h3 className="user-name">Bashir Hamza</h3>
                                        <span>Project Student</span>
                                    </div>
                                </div>
                            </div>
                            </Fade>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section colored" id="pricing-plans">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="center-heading">
                                <h2 className="section-title">Pricing Plans</h2>
                            </div>
                        </div>
                        <div className="offset-lg-3 col-lg-6">
                            <div className="center-text">
                                <p>Here is our pricing plan for anyone that is willing to learn web development.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-lg-3 col-md-6 col-sm-12" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.2s">
                           <Fade left>
                            <div className="pricing-item">
                                <div className="pricing-header">
                                    <h3 className="pricing-title">HTML & CSS</h3>
                                </div>
                                <div className="pricing-body">
                                    <div className="price-wrapper">
                                        <span className="currency">$</span>
                                        <span className="price">00.00</span>
                                        <span className="period">1 month</span>
                                    </div>
                                    <ul className="list">
                                        <li className="active">Free data for browsing</li>
                                        <li className="active">5hrs per day</li>
                                        <li className="active">5 days in a week</li>

                                    </ul>
                                </div>
                                <div className="pricing-footer">
                                    <a href="#contact-us" className="main-button">Contact us now</a>
                                   
                                </div>
                            </div>
                            </Fade>
                        </div>
                     


                        <div className="col-lg-6  col-sm-6" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.4s">
                            <Fade left>
                            <div className="pricing-item active">
                                <div className="pricing-header">
                                    <h3 className="pricing-title">JavaScript</h3>
                                </div>
                                <div className="pricing-body">
                                    <div className="price-wrapper">
                                        <span className="currency">$</span>
                                        <span className="price">00.00</span>
                                        <span className="period"> 1 month</span>
                                    </div>
                                    <ul className="list">
                                        <li className="active">Free data for browsing</li>
                                        <li className="active">5hrs per day</li>
                                        <li className="active">5 days in a week</li>

                                    </ul>
                                </div>
                                <div className="pricing-footer">
                                    <a href="#contact-us" className="main-button">Contact us now</a>
                                </div>
                            </div>
                            </Fade>
                        </div>



                        <div className="col-lg-3 col-md-6 col-sm-12" data-scroll-reveal="enter bottom move 50px over 0.6s after 0.6s">
                            <Fade right>
                            <div className="pricing-item">
                                <div className="pricing-header">
                                    <h3 className="pricing-title">Reactjs</h3>
                                </div>
                                <div className="pricing-body">
                                    <div className="price-wrapper">
                                        <span className="currency">$</span>
                                        <span className="price">00.00</span>
                                        <span className="period"> 1 month</span>
                                    </div>
                                    <ul className="list">
                                        <li className="active">Free data for browsing</li>
                                        <li className="active">5hrs per day</li>
                                        <li className="active">5 days in a week</li>

                                    </ul>
                                </div>
                                <div className="pricing-footer">
                                    <a href="#contact-us" className="main-button">Contact us now</a>
                                </div>
                            </div>
                            </Fade>
                        </div>

                    </div>

                </div>
            </section>



            <section className="mini" id="work-process">
                <div className="mini-content">
                    <div className="container">

                        <div className="row">
                            <div className="offset-lg-3 col-lg-6">
                                <div className="info">
                                    <h1>SOME  PROJECTS</h1>
                                    <p>Here are some of the projects that i did within my years of experince.</p>
                                </div>
                            </div>
                        </div>


                        <div className="row">

                            <div className="col-lg-2 col-md-3 col-sm-6 col-6">
                                <a href="#" className="mini-box">
                                    <i><img src="/tailor.jpeg" alt="" /></i>
                                    <strong>ZAZZAU TAILOR</strong>
                                    <span>DEV-LORD</span>
                                </a>
                            </div>


                            <div className="col-lg-2 col-md-3 col-sm-6 col-6">
                                <a href="#" className="mini-box">
                                    <i><img src="/arewa.jpeg" alt="" /></i>
                                    <strong>AREWA GIRLS</strong>
                                    <span>DEV-LORD</span>
                                </a>
                            </div>

                            <div className="col-lg-2 col-md-3 col-sm-6 col-6">
                                <a href="#" className="mini-box">
                                    <i><img src="/payapp.jpeg" alt="" /></i>
                                    <strong>PayApp</strong>
                                    <span>DEV-LORD</span>
                                </a>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-6 col-6">
                                <a href="#" className="mini-box">
                                    <i><img src="/mibusiness.png" alt="" /></i>
                                    <strong>MiBusiness</strong>
                                    <span>DEV-LORD</span>
                                </a>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-6 col-6">
                                <a href="#" className="mini-box">
                                    <i><img src="/tesla.jpeg" alt="" /></i>
                                    <strong>Tesla Clone</strong>
                                    <span>DEV-LORD</span>
                                </a>
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-6 col-6">
                                <a href="#" className="mini-box">
                                    <i><img src="/tee.png" alt="" /></i>
                                    <strong>TEE-ROBOT</strong>
                                    <span>DEV-LORD</span>
                                </a>
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            {/* <section className="section" id="blog">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="center-heading">
                        <h2 className="section-title">Blog Entries</h2>
                    </div>
                </div>
                <div className="offset-lg-3 col-lg-6">
                    <div className="center-text">
                        <p>Integer molestie aliquam gravida. Nullam nec arcu finibus, imperdiet nulla vitae, placerat nibh. Cras maximus venenatis molestie.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                 <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="blog-post-thumb">
                        <div className="img">
                            <img src="/blog-item-01.png" alt=""/>
                        </div>
                        <div className="blog-content">
                            <h3>
                                <a href="#">Vivamus ac vehicula dui</a>
                            </h3>
                            <div className="text">
                               Cras aliquet ligula dui, vitae fermentum velit tincidunt id. Praesent eu finibus nunc. Nulla in sagittis eros. Aliquam egestas augue.
                            </div>
                            <a href="#" className="main-button">Read More</a>
                        </div>
                    </div>
                </div> 
                <div className="col-lg-12 col-md- col-sm-12">
                    <div className="blog-post-thumb">
                        <div className="img">
                            <img src="/ni.png" alt=""/>
                        </div>
                        <div className="blog-content">
                            <h3>
                                <a href="#">Phasellus convallis augue</a>
                            </h3>
                            <div className="text">
                                Aliquam commodo ornare nisl, et scelerisque nisl dignissim ac. Vestibulum finibus urna ut velit venenatis, vel ultrices sapien mattis.
                            </div>
                            <a href="#" className="main-button">Read More</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="blog-post-thumb">
                        <div className="img">
                            <img src="/blog-item-03.png" alt=""/>
                        </div>
                        <div className="blog-content">
                            <h3>
                                <a href="#">Nam gravida purus non</a>
                            </h3>
                            <div className="text">
                                Maecenas eu erat vitae dui convallis consequat vel gravida nulla. Vestibulum finibus euismod odio, ut tempus enim varius eu.
                            </div>
                            <a href="#" className="main-button">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> */}

            <section className="section colored" id="contact-us">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="center-heading">
                                <h2 className="section-title">Contact us</h2>
                            </div>
                        </div>
                        <div className="offset-lg-3 col-lg-6">
                            <div className="center-text">
                                <p>Thank you for taking the time to explore our portfolio.
                                     We hope you found it informative and inspiring. If you have any
                                      questions about our services or would like to discuss a potential project, 
                                       please don't hesitate to contact us.

                            You can reach us by phone or email, and we'll be happy to respond as soon as possible. We pride ourselves
                            on providing excellent customer service and look forward to the opportunity to work with you.

                            Thank you again for considering our portfolio, and we hope to hear from you soon.</p>
                            <span><b>Email:</b> devlord1250@gmail.com</span>
                            <p><b>TELL:</b>+234 7037 4355 36</p>

                            </div>
                        </div>
                    </div>

                    <div className="row">


                        <div className="col-lg-8 col-md-6 col-sm-12">
                            <div className="contact-form">
                                <form id="contact" onSubmit={submitHandler} >
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <fieldset>
                                                <input name="name" value={formData.name || ""} type="text" onChange={changeHandler} className="form-control" id="name" placeholder="Fullname......" required="" />
                                            </fieldset>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <fieldset>
                                                <input name="email" type="email"  value={formData.email || ""}  onChange={changeHandler} className="form-control" id="email" placeholder="Email......" required="" />
                                            </fieldset>
                                        </div>
                                        <div className="col-lg-12">
                                            <fieldset>
                                                <textarea name="subject"  value={formData.subject || ""}  onChange={changeHandler} rows="6" className="form-control" id="message" placeholder="Message us...." required="" />
                                            </fieldset>
                                        </div>
                                        <Flip>
                                        <div className="col-lg-12">
                                            <fieldset>
                                                <button type="submit" id="form-submit" className="main-button">Send Message</button>
                                            </fieldset>
                                        </div>
                                        </Flip>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <ul class="social">
                                <li><a href="https://www.facebook.com/musa.turawa.56"><i class="fa fa-facebook"></i></a></li>
                                <li><a href="https://instagram.com/musa.turawa?igshid=ZDdkNTZiNTM="><i class="fa fa-instagram"></i></a></li>
                                <li><a href="https://wa.link/s2fcjn"><i class="fa fa-whatsapp"></i></a></li>
                                <li><a href="https://github.com/turawa2"><i class="fa fa-github"></i></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <p class="copyright">Copyright &copy; 2023 Dev-Lord : Musa Turawa</p>
                        </div>
                    </div>
                </div>
            </footer>


        </React.Fragment>
    )
}

export default Home
